// IMPORT PACKAGE REFERENCES

import { createStore, applyMiddleware } from 'redux';

// IMPORT MIDDLEWARE

import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

// IMPORT REDUCERS

import { AppReducer } from '../reducers/AppReducer';


// CONFIGURE STORE

// export const createAppStore = () => {
//     return createStore(AppReducer, applyMiddleware(thunk, promiseMiddleware()));
// };

const store = createStore(AppReducer, applyMiddleware(thunk, promiseMiddleware()));

export default store;



// WEBPACK FOOTER //
// src/state/stores/AppStore.js